import Breadcrumbs from '@/components/Breadcrumbs'
import SectionHeading from '@/components/ui/SectionHeading'
import Seo from '@/components/Seo'
import { breadcrumbSchema } from '@/lib/schema'

const sections = [
  {
    title: '1. Acceptance of Terms',
    body: 'By accessing or using Mint Calculator (www.mintcalculator.com), you agree to be bound by these Terms of Service. If you do not agree, please discontinue use of the site.',
  },
  {
    title: '2. Description of Service',
    body: 'Mint Calculator provides free, browser-based calculators for personal budgeting, loan amortization, credit card and mortgage payoff, Web3/NFT mint gas estimation, and numismatic coin valuation. All results are estimates for informational purposes only, as detailed in our Financial Disclaimer.',
  },
  {
    title: '3. No Financial Advice',
    body: 'Nothing provided through this site constitutes financial, investment, tax, or legal advice. You are solely responsible for any decisions made based on calculator outputs.',
  },
  {
    title: '4. Acceptable Use',
    body: 'You agree not to misuse the site, including attempting to interfere with its operation, scraping content at scale without permission, or using it for any unlawful purpose.',
  },
  {
    title: '5. Intellectual Property',
    body: 'All content, design, and calculator logic on Mint Calculator is the property of its operators unless otherwise noted, and may not be reproduced without permission.',
  },
  {
    title: '6. Affiliate Relationships',
    body: 'This site participates in affiliate programs for financial products including savings accounts, loan refinancing, budgeting apps, and hardware wallets. We may earn a commission from qualifying actions taken through affiliate links.',
  },
  {
    title: '7. Limitation of Liability',
    body: 'Mint Calculator and its operators are not liable for any direct, indirect, incidental, or consequential damages arising from your use of, or inability to use, this site or reliance on its calculator outputs.',
  },
  {
    title: '8. Changes to Terms',
    body: 'We reserve the right to update these Terms of Service at any time. Continued use of the site constitutes acceptance of any changes.',
  },
]

function TermsOfService() {
  return (
    <>
      <Seo
        title="Terms of Service"
        description="Mint Calculator's Terms of Service governing use of our free personal finance, loan, Web3 mint gas, and numismatic coin valuation calculators."
        path="/terms-of-service"
        schema={breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Terms of Service', path: '/terms-of-service' }])}
      />
      <div className="mx-auto max-w-3xl px-4 py-10 sm:px-6 lg:px-8">
        <Breadcrumbs items={[{ name: 'Home', path: '/' }, { name: 'Terms of Service', path: '/terms-of-service' }]} />
        <SectionHeading title="Terms of Service" description="Last updated January 2025" />

        <div className="mt-8 space-y-6">
          {sections.map(s => (
            <div key={s.title}>
              <h3 className="text-sm font-semibold text-slate-100">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-400">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default TermsOfService
